(function(){
    angular.module('MonstaFTP').factory('jQuery', monstaJQuery);

    monstaJQuery.$inject = ['$window'];

    function monstaJQuery($window) {
        return $window.jQuery;
    }
})();